import React from 'react';

function QuestionCard({ question, onAnswer, selectedAnswer, questionIndex, disabled = false }) {
  const letters = ['A', 'B', 'C', 'D', 'E', 'F'];

  return (
    <section className="question-card" aria-labelledby={`question-${questionIndex}`}>
      <p className="question-label">Question {questionIndex + 1}</p>
      <h2 className="question-text" id={`question-${questionIndex}`}>{question.text}</h2>
      <div className="options-list" role="group" aria-label={`Answers for question ${questionIndex + 1}`}>
        {question.options.map((opt, idx) => (
          <button
            key={idx}
            type="button"
            className={`option-btn ${selectedAnswer === idx ? 'selected' : ''}`}
            onClick={() => onAnswer(idx)}
            disabled={disabled}
            aria-pressed={selectedAnswer === idx}
            aria-label={`Option ${letters[idx]}: ${opt}${selectedAnswer === idx ? ', selected' : ''}`}
          >
            <span className="option-letter">{letters[idx]}</span>
            <span className="option-text">{opt}</span>
            {selectedAnswer === idx && <span className="option-selected">Selected</span>}
          </button>
        ))}
      </div>
    </section>
  );
}

export default QuestionCard;
